import { InjectableIdentity, IdentityType } from '../identity';
import { initStorage } from './utils';
import { AMP_ID_STORAGE_KEY } from './constants';

import MemoryStorage from '@arc-publishing/sdk-subs-core/lib/utils/memoryStorage';
import CookieStorage from '@arc-publishing/sdk-subs-core/lib/utils/cookieStorage';

import getAMPReaderIDs from './getAMPReaderIDs';
import saveAMPReaderID from './saveAMPReaderID';
import checkAMPReaderID from './checkAMPReaderID';
import logoutAMPReaderID from './logoutAMPReaderID';
import authenticateAMPReaderID from './authenticateAMPReaderID';

import options from './options';
import { logPrefix } from './constants';

export default abstract class Amp {
  static _Identity: IdentityType | InjectableIdentity;
  static apiOrigin?: string = '';
  static _baseDomain?: string = '';
  static _selectedStorage: MemoryStorage | CookieStorage | Storage = initStorage();

  private static _ampReaderId: string = '';

  static get ampReaderId(): string {
    try {
      if (!this._ampReaderId && this._selectedStorage) {
        const existingReaderId = JSON.parse(
          this._selectedStorage.getItem(AMP_ID_STORAGE_KEY) || null
        );
        this._ampReaderId = existingReaderId ? existingReaderId : '';
      }
    } catch (e) {
      console.error(`${logPrefix}: ${e}`);
      this._ampReaderId = '';
    }
    return this._ampReaderId;
  }

  static set ampReaderId(ampReaderId: string) {
    try {
      if (ampReaderId) {
        this._selectedStorage.setItem(AMP_ID_STORAGE_KEY, JSON.stringify(ampReaderId));
        this._ampReaderId = ampReaderId;
        return;
      }
      this._selectedStorage.setItem(AMP_ID_STORAGE_KEY, JSON.stringify(null));
      this._ampReaderId = '';
    } catch (e) {
      console.error(`${logPrefix}: ${e}`);
      return;
    }
  }

  static options = options;
  static checkAMPReaderID = checkAMPReaderID;
  static getAMPReaderIDs = getAMPReaderIDs;
  static saveAMPReaderID = saveAMPReaderID;
  static logoutAMPReaderID = logoutAMPReaderID;

  static authenticateAMPReaderID = authenticateAMPReaderID;
}
